import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { IManagementUnitPagedRequest } from '../../../../model/apm/management-unit/request/management-unit-paged-request';
import { IManagementUnitAddEditRequest } from '../../../../model/apm/management-unit/request/management-unit-add-edit-request';
import { IManagementUnitListResponse } from '../../../../model/apm/management-unit/response/management-unit-list-response';
import { IManagementUnitResponse } from '../../../../model/apm/management-unit/response/management-unit-response';

const defaultPath = 'ManagementUnit';

// Paginação 0-based; a API limita PageSize a 100
const list = async (params: IManagementUnitPagedRequest): Promise<Pagination<IManagementUnitListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: {
            Term: params.term || undefined,
            IsActive: params.isActive,
            Page: params.page,
            PageSize: params.pageSize,
        }
    }).then((response) => Object.assign(new Pagination<IManagementUnitListResponse>(), response.data));
};

const getById = async (id: number): Promise<IManagementUnitResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IManagementUnitAddEditRequest): Promise<IManagementUnitResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: IManagementUnitAddEditRequest): Promise<IManagementUnitResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const changeStatus = async (id: number, isActive: boolean): Promise<IManagementUnitResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}/Status`,
        data: { isActive }
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const ManagementUnitAppService = { list, getById, add, edit, changeStatus, remove };
export default ManagementUnitAppService;
